import { getCookie } from "./cookie-helper";

export function setRmpCookie() {
  if (window.bamData.frequencyCookie?.expire) {
    document.cookie = `bad-freq-rmp=1; max-age=${window.bamData.frequencyCookie.expire * 60 * 60}; path=/`;
  } else {
    document.cookie = `bad-freq-rmp=1; max-age=${4 * 60 * 60}; path=/`;
  }
}

export function rmpAdAlreadyShown() {
  return !!getCookie("bad-freq-rmp");
}

function getRmpCss() {
  return `
    b-a-d[slotname="rich_media_premium"], b-a-d[slotname="mob_rich_media_premium"] {
      height: 100svh !important;
      overflow: hidden;
    }

    .ad-info_button {
      display: none;
    }
  `
}

export function buildRmpStructure(context) {
  const googleDiv = document.createElement("div");

  googleDiv.id = "rmp-container";
  googleDiv.slot = "rmp-container"; // Assign to shadow DOM slot

  // we check if the css rules already exists, if not we add them.
  if (!document.querySelector("style[data-rmp-css]")) {
    const style = document.createElement("style");
    style.dataset.rmpCss = '';
    style.innerHTML = getRmpCss();
    document.head.appendChild(style);
  }

  context.append(googleDiv);
}